import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { MODULE_REGISTRY } from "./modules/registry";
import useAuth from "./hooks/useAuth";
import SiteHome from "./site/SiteHome";
import SitePrivacyPage from "./site/SitePrivacyPage";
import SiteSupportPage from "./site/SiteSupportPage";
import SiteClaudePage from "./site/SiteClaudePage";
import SiteTermsPage from "./site/SiteTermsPage";
import CustomerPortalPage from "./portal/CustomerPortalPage";
import { isAppHost } from "./site/siteConfig";

import "./App.css";

function ModuleRouter() {
  const { tenantModule } = useAuth();
  const entry = MODULE_REGISTRY[tenantModule] || MODULE_REGISTRY["dms"];
  const ModuleApp = entry.app;
  return <ModuleApp />;
}

/*
  "/" is shared between the marketing site (decisionflow.in) and the product
  (app.decisionflow.in), which are served from the same build:

  - signed in            -> straight into the module, as before
  - signed out, app host -> the login page, as before
  - signed out, anywhere -> the marketing site

  Every other path falls through to the module router untouched.
*/
function HomeRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <div className="loading-screen">Loading...</div>;
  if (isAuthenticated) return <ModuleRouter />;
  if (isAppHost()) return <Navigate to="/login" replace />;
  return <SiteHome />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          {/*
            Customer share links. Declared above the catch-all so they never
            reach ModuleRouter, which would demand a staff login.
          */}
          <Route path="/portal/:token" element={<CustomerPortalPage />} />
          {/*
            Marketing/legal pages, reachable from the site footer regardless
            of host — declared above the catch-all for the same reason as the
            portal route above.
          */}
          <Route path="/privacy" element={<SitePrivacyPage />} />
          <Route path="/terms" element={<SiteTermsPage />} />
          <Route path="/support" element={<SiteSupportPage />} />
          <Route path="/claude" element={<SiteClaudePage />} />
          <Route path="/ai-assistants" element={<SiteClaudePage />} />
          <Route path="/*" element={<ModuleRouter />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
